// extracted by mini-css-extract-plugin
export default {"wrapper":"credits_wrapper__AUYjd","credits":"credits_credits__oLziW","button":"credits_button__HVDwk"};